(function IIFE() {
    'use strict';

    /////////////////////////////

    function StyleFactory($resource, Config) {
        'ngInject';

        return $resource(Config.HAUSSMANN_HOST + '/_ah/api/lumsites/v1/style/:methodKey', {}, {
            'delete': {
                isArray: false,
                method: 'DELETE',
                params: {
                    methodKey: 'delete',
                },
            },

            'get': {
                isArray: false,
                method: 'GET',
                params: {
                    methodKey: 'get',
                },
                url: Config.HAUSSMANN_HOST + '/_ah/api/lumsites/v1/style/:methodKey'
            },

            'list': {
                isArray: false,
                method: 'GET',
                params: {
                    methodKey: 'list',
                },
                url: Config.HAUSSMANN_HOST + '/_ah/api/lumsites/v1/style/:methodKey'
            },

            'save': {
                isArray: false,
                method: 'POST',
                params: {
                    methodKey: 'save',
                },
            },
        });
    }

    /////////////////////////////

    angular.module('Factories').factory('StyleFactory', StyleFactory);
})();
